const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Offices = () => import('~/pages/offices').then(m => m.default || m)
const Profile = () => import('~/pages/profile').then(m => m.default || m)
const Archives = () => import('~/pages/archives').then(m => m.default || m)
const Books = () => import('~/pages/books').then(m => m.default || m)
const Book = () => import('~/pages/book').then(m => m.default || m)
const News = () => import('~/pages/news').then(m => m.default || m)
const Information = () => import('~/pages/information').then(m => m.default || m)
const Product = () => import('~/pages/product').then(m => m.default || m)
const External = () => import('~/pages/external').then(m => m.default || m)
const External2 = () => import('~/pages/external2').then(m => m.default || m)
const Press = () => import('~/pages/press').then(m => m.default || m)
const Article = () => import('~/pages/article').then(m => m.default || m)
const Dialogue = () => import('~/pages/dialogue').then(m => m.default || m)
const Dialogues = () => import('~/pages/dialogues').then(m => m.default || m)

const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const ActivateUser = () => import('~/pages/auth/activate/user').then(m => m.default || m)
const ActivateEmail = () => import('~/pages/auth/activate/email').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home/index').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPersonal = () => import('~/pages/settings/personal').then(m => m.default || m)
const SettingsNotifications = () => import('~/pages/settings/notifications').then(m => m.default || m)
const SettingsEmail = () => import('~/pages/settings/email').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Publish = () => import('~/pages/publish').then(m => m.default || m)
const Updates = () => import('~/pages/updates').then(m => m.default || m)
const Release = () => import('~/pages/release').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },
  { path: '/offices/', name: 'offices', component: Offices },
  { path: '/profile/:id', name: 'profile', component: Profile },
  { path: '/archives/', name: 'archives', component: Archives },
  { path: '/books/', name: 'books', component: Books },
  { path: '/book/:id', name: 'book', component: Book },
  { path: '/books/:id', name: 'books.category', component: Books },
  
  { path: '/national_tax_agency/', name: 'external', component: External },
  { path: '/small_medium_enterprise_agency/', name: 'external2', component: External2 },
  { path: '/news/', name: 'news', component: News },
  { path: '/information/', name: 'information', component: Information },
  { path: '/product/', name: 'product', component: Product },
  { path: '/press/', name: 'press', component: Press },
  { path: '/article/:id', name: 'article', component: Article },
  { path: '/dialogue/', name: 'dialogues', component: Dialogues },
  { path: '/dialogue/:id', name: 'dialogue', component: Dialogue },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },
  { path: '/activate/user/:token', name: 'activate.user', component: ActivateUser },
  { path: '/activate/email/:token', name: 'activate.email', component: ActivateEmail },
  
  { path: '/publish', name: 'publish', meta: { label: 'publish' }, component: Publish },
  { path: '/publish/:id', name: 'publish.edit', meta: { label: 'publish' }, component: Publish },
  
  { path: '/updates', name: 'updates', meta: { label: 'updates' }, component: Updates },
  { path: '/updates/:id', name: 'updates.edit', meta: { label: 'updates' }, component: Updates },
  
  { path: '/release', name: 'release', meta: { label: 'release' }, component: Release },
  { path: '/release/:id', name: 'release.edit', meta: { label: 'release' }, component: Release },

  { path: '/home',
    component: Home,
    children: [
      { path: '', name: 'home', meta: { label: 'home' }, component: Home }
    ]
  },

  { path: '/settings',
    component: Settings,
    children: [
      { path: '', name: 'settings', meta: { label: 'settings' }, redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', meta: { label: 'your_info' }, component: SettingsProfile },
      { path: 'personal', name: 'settings.personal', meta: { label: 'your_personal_info' }, component: SettingsPersonal },
      { path: 'notifications', name: 'settings.notifications', meta: { label: 'notifications' }, component: SettingsNotifications },
      { path: 'email', name: 'settings.email', meta: { label: 'your_email' }, component: SettingsEmail },
      { path: 'password', name: 'settings.password', meta: { label: 'your_password' }, component: SettingsPassword }
    ]
  },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js